import { Theme } from '@material-ui/core/styles';
import { StepIconClasskey } from '@material-ui/core/StepIcon';

const MuiStepIcon = (theme: Theme): Partial<Record<StepIconClasskey, unknown>> => ({
    root: {
        zIndex: 1,
        '&$completed': {
            color: theme.palette.success.main,
        },
    },
    /* Pseudo-class applied to the root element if `completed={true}`. */
    completed: {},
});

export default MuiStepIcon;
